import { render, staticRenderFns } from "./eliminarUsuarioModal.vue?vue&type=template&id=01afeb87&scoped=true"
import script from "./eliminarUsuarioModal.vue?vue&type=script&lang=js"
export * from "./eliminarUsuarioModal.vue?vue&type=script&lang=js"
import style0 from "./eliminarUsuarioModal.vue?vue&type=style&index=0&id=01afeb87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01afeb87",
  null
  
)

export default component.exports